import React from 'react'

import _ from 'lodash'
import pointInPolygon from '@turf/boolean-point-in-polygon'
import bbox from '@turf/bbox'
import { polygon as createPolygon } from '@turf/helpers'

import Loading from '../../../felles/loading'
import Repository from '../../../felles/repository'
import NkaButton from 'nka-button'
import NkaSelect from 'nka-select'

import Kart from './kartRediger'
import Filterpanel from './filterpanel'
import Vannmaalerliste from './maalerliste'

import PlanlagteSort from './planlagteDnd'
import JaNeiDialog from '../../../felles/Dialogs/JaNeiDialog.jsx'
import OkDialog from '../../../felles/Dialogs/OkDialog.jsx'

import './rediger.css'
import 'nka-button/dist/style.css'
import 'nka-select/dist/style.css'

const RedigerArbeidslistePresentation = ({
    arbeidsliste,
    vannmaalere,
    valgtPlanlagtMaaler,
    onPlanlagtMaalerValgt,
    onVannmaalereValgt,
    leggTilMaalere,
    fjernMaaler,
    onClose,
    filter,
    onFilterChanged,
    soner,
    statusTyper,
    onToggleVisListe,
    visListe,
    avlesertyper,
    avtaletyper,
    viewport,
    onViewportChanged,
    valgteMaalere,
    isLeggtilVannmaalereModalOpen,
    lukkModalForLeggeTilVannmaalere,
    sorterArbeidsliste,
    oppdaterRekkefoelgeForArbeidsliste,
    onFilterChangedKart,
    isVannmaalerLagtTilModalOpen
}) => {
    // ta bort målere som ligger i planlagt-listen
    if (vannmaalere) {
        vannmaalere = _.reject(vannmaalere, vm =>
            _.some(arbeidsliste.VannmaalerePlanlegging, p => p.MaalerId === vm.Id)
        )
    }

    if(valgteMaalere){
        valgteMaalere = _.filter(valgteMaalere, v => !v.ErIArbeidsliste)
    }

    return (
        <div className="vm-rediger">
            <div className="side-panel-left">
                <Filterpanel
                    filter={filter}
                    soner={soner}
                    statusTyper={statusTyper}
                    onFilterChanged={onFilterChanged}
                    visListe={visListe}
                    onToggleVisListe={onToggleVisListe}
                    avlesertyper={avlesertyper}
                    avtaletyper={avtaletyper}
                />

                <div className="button-container">
                    <NkaButton onClick={() => onToggleVisListe()}>
                        {visListe ? 'Vis kart' : 'Vis liste'}
                    </NkaButton>
                </div>
            </div>

            <div className="content-panel">
                {visListe ? (
                    <Vannmaalerliste
                        vannmaalere={vannmaalere}
                        onVannmaalereValgt={onVannmaalereValgt}
                        valgteMaalere={valgteMaalere}
                    />
                ) : (
                    <Kart
                        viewport={viewport}
                        onViewportChanged={onViewportChanged}
                        planlagte={arbeidsliste.VannmaalerePlanlegging}
                        vannmaalere={vannmaalere}
                        leggTilMaaler={maaler => leggTilMaalere([maaler])}
                        fjernMaaler={fjernMaaler}
                        filter={filter}
                        onFilterChanged={onFilterChangedKart}
                        valgtPlanlagtMaaler={valgtPlanlagtMaaler}
                        onPlanlagtMaalerValgt={onPlanlagtMaalerValgt}
                        valgteMaalere={valgteMaalere}
                    />
                )}

                <JaNeiDialog
                    melding={'Du har markert ' + valgteMaalere.length + ' vannmålere'}
                    isOpen={isLeggtilVannmaalereModalOpen}
                    tittel={'Utvalg'}
                    okKnappTekst="Legg til"
                    onAvbryt={lukkModalForLeggeTilVannmaalere}
                    onOk={() => onVannmaalereValgt(valgteMaalere)}
                />

                <OkDialog
                    tittel="Info"
                    onOk={lukkModalForLeggeTilVannmaalere}
                    onClose={lukkModalForLeggeTilVannmaalere}
                    isOpen={isVannmaalerLagtTilModalOpen}
                    melding="Vannmåler er lagt til i en annen arbeidsliste"
                />
            </div>

            <div className="side-panel-right">
                <h2 className="header">Arbeidsliste</h2>
                <div className="form-group">
                    <label className="control-label">Sorter etter adresse</label>
                    <div className="form-group-control">
                        <select
                            className="form-control"
                            onChange={e => sorterArbeidsliste(e.target.value)}
                        >
                            <option key="_blank" value="" />
                            <option value="1">Synkende</option>
                            <option value="2">Stigende</option>
                        </select>
                    </div>
                </div>

                <PlanlagteSort
                    vannmaalere={arbeidsliste.VannmaalerePlanlegging}
                    valgtPlanlagtMaaler={valgtPlanlagtMaaler}
                    onPlanlagtMaalerValgt={onPlanlagtMaalerValgt}
                    fjernMaaler={fjernMaaler}
                    onClose={() => onClose()}
                    updateItems={maalere => oppdaterRekkefoelgeForArbeidsliste(maalere)}
                />

                <NkaButton className="btn-block" buttontype="primary" onClick={onClose}>
                    Ferdig
                </NkaButton>
            </div>
        </div>
    )
}

class RedigerArbeidslisteContainer extends React.Component {
    state = {
        arbeidsliste: null,
        valgtPlanlagtMaaler: null,
        soner: [],
        filter: {
            adresse: null, //'',
            sone: null, //'',
            dato: null,
            status: null, //'',
            avtaletype: null, //'',
            avlesertype: null,
            polygon: null,
            frakart: false
        },
        loading: true,
        loadingText: 'Henter målere',
        vannmaalere: null,
        filteredVannmaalere: null,
        statusTyper: [],
        visListe: true,
        viewport: null,
        valgteMaalere: [],
        isLeggtilVannmaalereModalOpen: false,
        isVannmaalerLagtTilModalOpen: false,
        brukere: []
    }

    repository = new Repository()

    constructor() {
        super()

        this.viewportChanged = this.viewportChanged.bind(this)
        this.vannmaalereValgt = this.vannmaalereValgt.bind(this)
        this.lukkModalForLeggeTilVannmaalere = this.lukkModalForLeggeTilVannmaalere.bind(this)
        this.sorterArbeidsliste = this.sorterArbeidsliste.bind(this)
    }

    componentDidMount() {
        Promise.all([
            this.hentArbeidsliste(),
            this.repository.hentVannmaalere(),
            this.repository.hentSoner(),
            this.repository.hentMaalerstatus(),
            this.repository.hentAvlesertyper()
        ]).then(([arbeidsliste, maalere, soner, statusTyper, avlesertyper]) => {
            this.onVannmaalereMottatt(maalere, avlesertyper)
            this.onSonerMotatt(soner)
            this.onStatusTyperMotatt(statusTyper)
            this.onAvlesertyperMottatt(avlesertyper)
            this.onArbeidslisteMottatt(arbeidsliste)
            this.setState(s => ({ loading: false }))
        })
    }

    hentArbeidsliste() {
        return this.repository.hentArbeidslisteMedId(this.props.match.params.ListeId)
    }

    onArbeidslisteMottatt(liste) {
        this.setState({
            arbeidsliste: liste,
            brukere: liste.Brukere
        })
    }

    onVannmaalereMottatt(liste, avlesertyper) {
        let avlesertyperKeyed = _.keyBy(avlesertyper, 'Id')
        liste.forEach(e => {
            let at = avlesertyperKeyed[e.Avlesertype]
            if (at) e.AvlesertypeTekst = at.Tekst
        })

        let avtaletyper = _.uniq(_.map(liste, _.property('Avtaletype')))

        this.setState({
            vannmaalere: liste,
            filteredVannmaalere: liste,
            avtaletyper
        })
    }

    onAvlesertyperMottatt(liste) {
        this.setState({
            avlesertyper: liste
        })
    }

    onSonerMotatt(soner) {
        this.setState({
            soner: soner
        })
    }

    onStatusTyperMotatt(statusTyper) {
        this.setState({
            statusTyper: statusTyper
        })
    }

    onPlanlagtMaalerValgt(maalerId) {
        this.setState(s => ({
            valgtPlanlagtMaaler: s.valgtPlanlagtMaaler === maalerId ? null : maalerId
        }))
    }

    onLeggTilMaalere() {
        let { arbeidsliste } = this.state

        let vannmaalerIdListe = arbeidsliste.VannmaalerePlanlegging.map(vm => vm.MaalerId)

        let oppdatertArbeidsliste = {
            Id: arbeidsliste.Id,
            Tittel: arbeidsliste.Tittel,
            Beskrivelse: arbeidsliste.Beskrivelse,
            Vannmaalere: vannmaalerIdListe,
            Startdato: arbeidsliste.Startdato,
            Status: arbeidsliste.Status,
            StartTidspunkt: arbeidsliste.StartTidspunkt,
            SluttTidspunkt: arbeidsliste.SluttTidspunkt
        }

        oppdatertArbeidsliste.ValgteBrukerIder = _.map(this.state.brukere, 'BrukerGUID')
        this.setState(s => ({
            loadingText: 'Oppdatere arbedisliste',
            loading: true
        }))

        this.repository.oppdateArbeidsliste(oppdatertArbeidsliste).then(d => {
            this.props.history.push('/planlegging/' + this.props.match.params.ListeId)
        })
    }

    onFjernMaaler(maaler) {
        let { arbeidsliste } = this.state
        let idListe = arbeidsliste.VannmaalerePlanlegging.map(vm => vm.MaalerId)
        idListe = _.without(idListe, maaler.MaalerId)

        let oppdatertPlanlagtListe = _.filter(
            arbeidsliste.VannmaalerePlanlegging,
            m => m.MaalerId !== maaler.MaalerId
        )

        let oppdatertArbeidsliste = {
            Id: arbeidsliste.Id,
            Tittel: arbeidsliste.Tittel,
            Beskrivelse: arbeidsliste.Beskrivelse,
            Vannmaalere: idListe,
            Startdato: arbeidsliste.Startdato,
            Status: arbeidsliste.Status,
            VannmaalerePlanlegging: oppdatertPlanlagtListe,
            StartTidspunkt: arbeidsliste.StartTidspunkt,
            SluttTidspunkt: arbeidsliste.SluttTidspunkt
        }

        this.setState({
            arbeidsliste: oppdatertArbeidsliste
        })
    }

    onClose() {
        this.onLeggTilMaalere()
    }

    filterAdresse(adresseFilter, maalere) {
        if (!adresseFilter) return maalere
        adresseFilter = adresseFilter.toLowerCase().trim()
        if (!adresseFilter.length) return maalere

        return _.filter(
            maalere,
            m =>
                m.Maaleradresse.toLowerCase().includes(adresseFilter) ||
                (m.Maalernummer && m.Maalernummer.includes(adresseFilter))
        )
    }

    filterSone(soneFilter, maalere) {
        if (!soneFilter) return maalere

        let sone = _.find(this.state.soner, s => s.Id === soneFilter)
        if (!sone || !sone.Tekst || !sone.Tekst.length) return maalere
        return _.filter(maalere, m => m.Sone === sone.Tekst)
    }

    filter(property, filter, maalere) {
        if (!filter || (typeof filter === 'string' && !filter.length)) return maalere
        return _.filter(maalere, m => m[property] === filter)
    }

    filterDato(datoFilter, maalere) {
        if (!datoFilter) return maalere

        return _.filter(
            maalere,
            m => !m.Installasjonsdato || new Date(m.Installasjonsdato).getFullYear() < datoFilter
        )
    }

    filterKartutvalg(polygon, maalere) {
        if (!polygon || polygon.length < 3) return maalere

        polygon = _.concat(polygon, [polygon[0]]) // turf krever lukket polygon

        let turfPolygon = createPolygon([polygon])
        turfPolygon.bbox = bbox(turfPolygon)

        let antallFraKartUtvalg = _.filter(maalere, m => {
            if (!m.Latitude || m.Latitude === 'NaN' || (!m.Longitude || m.Longitude === 'NaN'))
                return false
            let res = pointInPolygon([m.Latitude, m.Longitude], turfPolygon)
            return res
        })

        this.setState({
            isLeggtilVannmaalereModalOpen: true
        })

        return antallFraKartUtvalg
    }

    onFilterChangedKart(filter) {
        let newFilter = Object.assign({}, this.state.filter)
        newFilter.polygon = filter.polygon

        this.onFilterChanged(newFilter)
    }

    onFilterChanged(filter) {
        if (!this.state.vannmaalere || !this.state.vannmaalere.length) return
        let filtered = this.filterAdresse(filter.adresse, this.state.vannmaalere)
        filtered = this.filterSone(filter.sone, filtered)
        filtered = this.filterDato(filter.dato, filtered)
        filtered = this.filter('Status', filter.status, filtered)
        filtered = this.filter('Avlesertype', filter.avlesertype, filtered)
        filtered = this.filter('Avtaletype', filter.avtaletype, filtered)
        filtered = this.filterKartutvalg(filter.polygon, filtered)
        
        //filtered = _.filter(filtered, m => !m.ErIArbeidsliste );
        
        let newState = {
            filter,
            filteredVannmaalere: filtered
        }

        if (filter.polygon !== this.state.polygon && !_.eq(filter.polygon, this.state.polygon)) {
            newState.valgteMaalere = filter.polygon ? filtered : []
        }

        this.setState(newState)
    }

    toggleVisListe() {
        this.setState(s => ({
            visListe: !s.visListe
        }))
    }

    viewportChanged(viewport) {
        this.setState({ viewport })
    }

    vannmaalereValgt(utvalg) {
        if (!utvalg) return
        let { arbeidsliste } = this.state

        var nyeVm = _.map(utvalg, function(value) {
            if (value.ErIArbeidsliste) {
                return undefined
            } else {
                let nyVannmaalerPlanlagt = {
                    MaalerId: value.Id,
                    Maalepunktadresse: value.Maaleradresse,
                    Husnummer: value.Husnummer,
                    Husbokstav: value.Husbokstav,
                    Latitude: value.Latitude,
                    Longitude: value.Longitude
                }
                return nyVannmaalerPlanlagt
            }
        })
        
        if (!nyeVm[0]) {
            this.setState({
                isVannmaalerLagtTilModalOpen: true
            })
            return
        } else {
            let nyVmliste = _.concat(arbeidsliste.VannmaalerePlanlegging, nyeVm)

            let oppdatertArbeidsliste = {
                Id: arbeidsliste.Id,
                Tittel: arbeidsliste.Tittel,
                Beskrivelse: arbeidsliste.beskrivelse,
                Startdato: arbeidsliste.Startdato,
                Status: arbeidsliste.Status,
                VannmaalerePlanlegging: nyVmliste,
                StartTidspunkt: arbeidsliste.StartTidspunkt,
                SluttTidspunkt: arbeidsliste.SluttTidspunkt
            }

            let newFilter = Object.assign({}, this.state.filter)
            newFilter.polygon = null

            this.onFilterChanged(newFilter)

            this.setState({
                arbeidsliste: oppdatertArbeidsliste,
                isLeggtilVannmaalereModalOpen: false
            })
        }
    }

    lukkModalForLeggeTilVannmaalere() {
        this.setState({
            isLeggtilVannmaalereModalOpen: false
        })
    }

    sorterArbeidsliste(verdi) {
        let { arbeidsliste } = this.state

        let rekkefoelge =
            verdi === '1'
                ? _.orderBy(
                      arbeidsliste.VannmaalerePlanlegging,
                      ['Maalepunktadresse', 'Husnummer'],
                      ['desc', 'desc']
                  )
                : _.orderBy(
                      arbeidsliste.VannmaalerePlanlegging,
                      ['Maalepunktadresse', 'Husnummer'],
                      ['asc', 'asc']
                  )

        let oppdatertArbeidsliste = {
            Id: arbeidsliste.Id,
            Tittel: arbeidsliste.Tittel,
            Beskrivelse: arbeidsliste.beskrivelse,
            Startdato: arbeidsliste.Startdato,
            Status: arbeidsliste.Status,
            VannmaalerePlanlegging: rekkefoelge,
            StartTidspunkt: arbeidsliste.StartTidspunkt,
            SluttTidspunkt: arbeidsliste.SluttTidspunkt
        }

        this.setState({
            arbeidsliste: oppdatertArbeidsliste
        })
    }

    oppdaterRekkefoelgeForArbeidsliste(vannmaalere) {
        let { arbeidsliste } = this.state
        arbeidsliste.VannmaalerePlanlegging = vannmaalere

        this.setState({
            arbeidsliste
        })
    }

    render() {
        if (this.state.loading) return <Loading tekst={this.state.loadingText} />

        const { arbeidsliste } = this.state
        if (!arbeidsliste) return null

        return (
            <RedigerArbeidslistePresentation
                arbeidsliste={this.state.arbeidsliste}
                vannmaalere={this.state.filteredVannmaalere}
                valgtPlanlagtMaaler={this.state.valgtPlanlagtMaaler}
                onPlanlagtMaalerValgt={maalerId => this.onPlanlagtMaalerValgt(maalerId)}
                leggTilMaalere={maalere => this.vannmaalereValgt(maalere)}
                fjernMaaler={maaler => this.onFjernMaaler(maaler)}
                onClose={() => this.onClose()}
                filter={this.state.filter}
                soner={this.state.soner}
                statusTyper={this.state.statusTyper}
                avtaletyper={this.state.avtaletyper}
                avlesertyper={this.state.avlesertyper}
                onFilterChanged={f => this.onFilterChanged(f)}
                onFilterChangedKart={f => this.onFilterChangedKart(f)}
                visListe={this.state.visListe}
                onToggleVisListe={() => this.toggleVisListe()}
                onViewportChanged={this.viewportChanged}
                viewport={this.state.viewport}
                onVannmaalereValgt={this.vannmaalereValgt}
                valgteMaalere={this.state.valgteMaalere}
                isLeggtilVannmaalereModalOpen={this.state.isLeggtilVannmaalereModalOpen}
                isVannmaalerLagtTilModalOpen={this.state.isVannmaalerLagtTilModalOpen}
                lukkModalForLeggeTilVannmaalere={() =>
                    this.setState({
                        isLeggtilVannmaalereModalOpen: false,
                        isVannmaalerLagtTilModalOpen: false
                    })
                }
                sorterArbeidsliste={this.sorterArbeidsliste}
                oppdaterRekkefoelgeForArbeidsliste={maalere =>
                    this.oppdaterRekkefoelgeForArbeidsliste(maalere)
                }
            />
        )
    }
}

export default RedigerArbeidslisteContainer



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/rediger.jsx